

const popperInitializer = () => {
  $('[data-toggle="popover"]').popover();
}

export {
  popperInitializer
}


// WEBPACK FOOTER //
// ./App/components/initializers/popper-tooltip.js